/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type WorkspaceDetailScope =
  (typeof WorkspaceDetailScope)[keyof typeof WorkspaceDetailScope];

export const WorkspaceDetailScope = {
  PERSONAL: 'PERSONAL',
  ORGANIZATION: 'ORGANIZATION',
} as const;
